// extracted by mini-css-extract-plugin
export var cardHeader = "_gh-0";
export var reorderHandle = "_gh-3";
export var titleArea = "_gh-1";
export var titleAreaWithHandle = "_gh-2";